import { useTranslations } from "use-intl";

import { Button } from "@/components/Button/Button";
import { DrawerTopBarWithAction } from "@/components/Drawer/DrawerTopBar";
import { SwipeableDrawer } from "@/components/Drawer/SwipeableDrawer";
import type { StopsOptions } from "@/features/flights/types/types";

import { StopsFilter } from "./flight-filters/StopsFilter";

type Props = {
  open: boolean;
  defaultValue?: StopsOptions;
  value?: StopsOptions;
  onSubmit: (newValue?: StopsOptions) => void;
  onClose: () => void;
};

export const StopsFilterDrawer = ({
  open,
  defaultValue,
  value,
  onSubmit,
  onClose,
}: Props) => {
  const t = useTranslations();

  return (
    <SwipeableDrawer open={open} onClose={onClose}>
      <DrawerTopBarWithAction
        onCloseClick={onClose}
        title={t("flights.stops")}
        actionElement={
          <Button
            onClick={() => {
              onSubmit(defaultValue);
            }}
            variant="text"
            size="small"
          >
            {t("clearFilter")}
          </Button>
        }
      />

      <div className="mt-4">
        <StopsFilter value={value} onChange={onSubmit} />
      </div>
    </SwipeableDrawer>
  );
};
